import { DataGroupPageDtoToEntity } from "src/app/features/DataGroup/services/mappers/DataGroupPageDtoToEntity";
import type { DataGroupDto } from "src/app/features/DataGroup/types/DataGroupDto";
import type { DataGroupEntity } from "src/app/features/DataGroup/types/DataGroupEntity";
import { ResourceName } from "../../core/router/config/ResourceName";
import { baseAuthApi } from "../../core/service/baseApi";
import type { ResourcePageDto } from "../../core/types/be/ResourcePageDto";

export const dataGroupsApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadDataGroups: builder.query<ReadonlyArray<DataGroupEntity>, unknown>({
            providesTags: ["mainCache"],
            query: ({ userId }) => ({
                url: `/users/${userId}/${ResourceName.DATA_GROUPS}`,
                method: "GET",
            }),
            transformResponse: (response: ResourcePageDto<DataGroupDto>) => DataGroupPageDtoToEntity(response),
        }),
    }),
});

export const { useLoadDataGroupsQuery } = dataGroupsApi;
